import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

class BrowserHistory {
  constructor() {
    this.listeners = [];
  }

  goBack() {
    this.navigate(-1);
  }

  push(location) {
    if (typeof location === 'string') {
      this.navigate(location);
    } else if (typeof location === 'object' && location.pathname) {
      this.navigate(location.pathname, { state: location.state });
    }
  }

  replace(location) {
    if (typeof location === 'string') {
      this.navigate(location, { replace: true });
    } else if (typeof location === 'object' && location.pathname) {
      this.navigate(location.pathname, { replace: true, state: location.state });
    }
  }

  listen(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  navigate = null;

  setNavigate(navigate) {
    this.navigate = navigate;
    this.listeners.forEach((listener) => listener());
  }
}

const browserHistory = new BrowserHistory();

export const useBrowserHistory = () => {
  const navigate = useNavigate();

  useEffect(() => {
    browserHistory.setNavigate(navigate);
  }, [navigate]);

  return browserHistory;
};
